// extracted by mini-css-extract-plugin
module.exports = {"lightBox":"LightBox__lightBox--239","layer":"LightBox__layer--1_z","layout":"LightBox__layout--2NW","popup":"LightBox__popup--1Vj"};